<template>
    <v-dialog @input="change" value="true" :max-width="width">
        <v-card>
            <v-card-title class="headline">{{ title }}</v-card-title>
            <v-card-text>{{ message }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="choose(true) ">{{ btnOk     }}</v-btn>
                <v-btn color="primary" flat @click="choose(false)">{{ btnCancel }}</v-btn>
            </v-card-actions>
        </v-card>   
    </v-dialog>    
</template>

<script>
export default {
    props : {
        btnOk : {
            type : String,
            default : 'Ok'
        },
        btnCancel : {
            type : String,
            default : 'Cancel'
        },
        title : {
            type : String,
            default : 'Confirm'
        },
        message : {
            type : String,
            default : 'Are you sure?'
        },
        width : {
            type : Number,
            default : 300
        }

    },

    data() {
        return {
            value : false
        };
    },

    methods : {
        choose(value) {
            this.$emit('result', value);
            this.value = value;
            this.$destroy();
        },

        change() {
            this.$destroy();
        }
    }
    
}
</script>
